import { Layout } from 'antd';
import { Content } from 'antd/es/layout/layout';
import { type FC, type PropsWithChildren } from 'react';
import { Outlet } from 'react-router-dom';

type AuthLayoutProps = PropsWithChildren;

export const AuthLayout: FC<AuthLayoutProps> = ({ children }) => {
  return (
    <Layout style={{ height: '100vh', overflow: 'hidden', backgroundColor: 'var(--color-bg-muted)' }}>
      <Content>{children || <Outlet />}</Content>
    </Layout>
  );
};
